import React, { Component } from 'react'
import { withRouter, Link } from 'react-router-dom'
import Waypoint from 'react-waypoint'
import Heading from 'grommet/components/Heading'
import Image from 'grommet/components/Image'
import Paragraph from 'grommet/components/Paragraph'
import { Helmet } from 'react-helmet'
import webDesignDeskImage from '../../resources/images/web-design-desk.jpeg'
import './CmsArticle.css'

class CmsArticle extends Component {
  handleWaypointEnter = () => {
    const { setParticleVisibility } = this.props
    setParticleVisibility('home', 'sectionOneParticlesVisible', false)
    setParticleVisibility('home', 'sectionTwoParticlesVisible', true)
    //setAboutVisibility(true)
    //setSectionProperty('about', 'separatorBarExpanded', true)
  }

  render() {
    const { title, description } = this.props
    return (
      <div className="CmsArticle">
        <Helmet>
          <title>{`${title} - Copper Coast Technologies`}</title>
          <meta name="description" content={description} />
        </Helmet>
        <Waypoint scrollableAncestor={window} onEnter={this.handleWaypointEnter}/>
        <div className="CmsArticle-container">
          <Heading strong className="CmsArticle-heading" tag="h2">{title}</Heading>
          <Image className="CmsArticle-image" src={webDesignDeskImage} alt={`${title} - Web Design Agency Ireland`} full={false} size="medium"/>
          <Paragraph className="CmsArticle-mainParagraph">
            <Link className="CmsArticle-link" to="/#ready-to-start"><span className="CmsArticle-contactUs">Contact us today</span></Link> about your <span className="CmsArticle-queryText">{title}</span> queries<br/>
            {description}
          </Paragraph>
          <Paragraph className="CmsArticle-mainParagraph">
            Based in Waterford Ireland, we are a luxury web design agency with a passionate team and international portfolio of successful web applications and mobile apps.
            We believe in developing aesthetically beautiful websites with an engineering under-the-hood that will ensure your website is sustainable and future-proof.
          </Paragraph>
          <Paragraph className="CmsArticle-mainParagraph">
            We are crafters of effective solutions for mobile and web.
            As a young company we are passionate about helping our clients succeed in an increasingly digital world.
            Our dedicated service, knowledge and quality is what sets us apart.
          </Paragraph>
        </div>
      </div>
    )
  }
}

export default withRouter(CmsArticle)


// WEBPACK FOOTER //
// ./src/components/CmsArticle/index.js